export function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export function convertDate(dateString) {
  const regex = /^\d{2}-\d{2}-\d{4}$/;

  if (regex.test(dateString)) {
    const parts = dateString.split("-");
    const newDate = [parts[2], parts[1], parts[0]];
    return newDate.join("-");
  } else {
    return dateString;
  }
}

export function cleanPhone(phone) {
  if (!phone) return undefined;
  const cleaned = phone.replace(/[\s\-\(\)\.'\/]/g, "");
  if (cleaned.startsWith("00")) return "+" + cleaned.slice(2);
  if (cleaned.startsWith("0")) return "+33" + cleaned.slice(1);
  return cleaned;
}

export function formatDateToFrench(date) {
  if (!date) return "";
  return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
}

export const groupRenewalsByPrescription = (renewals) => {
  const groups = [];
  for (const renewal of renewals) {
    const groupKey = renewal.doctor?.code && renewal.date ? `${renewal.doctor.code}-${renewal.date.slice(0, 10)}` : renewal.silRenewalId;
    const group = groups.find((candidate) => candidate.key === groupKey);
    if (group) group.renewals.push(renewal);
    else groups.push({ key: groupKey, date: renewal.date, doctor: renewal.doctor, renewals: [renewal] });
  }
  return groups;
};

export function formatBirthdate(value) {
  if (!value) return null;
  const date = new Date(value);
  if (!Number.isNaN(date.getTime())) {
    return date.toLocaleDateString("fr-FR", { day: "2-digit", month: "long", year: "numeric" });
  }

  if (typeof value === "string") {
    const trimmed = value.split("T")[0];
    return trimmed.replace(/-/g, "/");
  }

  return value;
}

export function formatINS(value) {
  if (!value) return null;
  return value
    .replace(/\s+/g, "")
    .replace(/(.{2})/g, "$1 ")
    .trim();
}

export function formatAddress({ address, zipCode, city, country }) {
  return [address, [zipCode, city].filter(Boolean).join(" "), country].filter(Boolean).join(", ");
}

const COOKIE_CONSENT_KEY = "cookieConsent";
const COOKIE_CONSENT_MAX_AGE = 6 * 30 * 24 * 60 * 60 * 1000;
export const COOKIE_CONSENT_EVENT = "cookie-consent-changed";

export function getCookieConsent() {
  try {
    const stored = JSON.parse(localStorage.getItem(COOKIE_CONSENT_KEY));
    if (!stored?.value || Date.now() - stored.date > COOKIE_CONSENT_MAX_AGE) return null;
    return stored.value;
  } catch (_) {
    return null;
  }
}

export function setCookieConsent(value) {
  try {
    localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify({ value, date: Date.now() }));
  } catch (_) {}
}

export const compareByOrder = (a, b) => {
  if (a.order == null) return b.order == null ? 0 : 1;
  if (b.order == null) return -1;
  return a.order < b.order ? -1 : a.order > b.order ? 1 : 0;
};
